import React from "react";
import { Node, Handle, Position } from "reactflow";
import { ButtonsNodeData } from "../../models/buttonsNode";
import { CLASS_NAME } from "../../constants/cssClassNames";
import { Layout } from "../../models/common";
import Button from "../button/Button";
import "./ButtonsNode.css";

export interface ButtonsNodeProps
    extends Omit<Node<ButtonsNodeData>, "position"> {}

const ButtonsNode = ({ id, data }: ButtonsNodeProps) => {
    const layout: Layout = data?.layout ?? Layout.Horizontal;
    const buttons = data.buttons;
    const nextTriggers = data.nextTriggers;

    return (
        <div className={CLASS_NAME.BUTTONS_NODE}>
            <div className={CLASS_NAME.BUTTONS_NODE_LABEL}>
                {data?.label ?? "Label"}
            </div>
            {!data.isFirst && (
                <Handle
                    type="target"
                    position={
                        layout === Layout.Horizontal
                            ? Position.Left
                            : Position.Top
                    }
                    id={`${id}-left`}
                />
            )}
            {(!buttons?.length || !!nextTriggers?.length) && (
                <Handle
                    type="source"
                    position={
                        layout === Layout.Horizontal
                            ? Position.Right
                            : Position.Top
                    }
                    id={`${id}-right`}
                />
            )}
            <div className={CLASS_NAME.BUTTONS_NODE_BUTTONS}>
                {buttons?.length
                    ? buttons?.map((button, index) => (
                          <Button
                              key={`${index}-${
                                  button.inputId ?? button.outputId ?? ""
                              }`}
                              layout={layout}
                              inputId={button?.inputId}
                              outputId={button?.outputId}
                              label={button?.label ?? ""}
                          />
                      ))
                    : null}
            </div>
        </div>
    );
};

export default ButtonsNode;
